import Dashboard from "components/layout/Dashboard";
import DashboardContent from "components/layout/DashboardContent";
import CauseWorkbookPage from "components/reports/CauseWorkbookPage";
import { useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

const ProgramApp = () => {
  const [isFullWidth, setIsFullWidth] = useState(true);

  return (
    <div className={"app"}>
      <Dashboard>
        <DashboardContent isFullWidth={isFullWidth}>
          <Routes>
            <Route index element={<Navigate to={"cause"} replace />} />
            <Route
              path={"cause"}
              element={
                <CauseWorkbookPage
                  isFullWidth={isFullWidth}
                  onToggleFullWidth={setIsFullWidth}
                />
              }
            />
          </Routes>
        </DashboardContent>
      </Dashboard>
    </div>
  );
};

export default ProgramApp;
